import React from "react";
import { IconButton } from "@mui/material";
import MapIcon from "@mui/icons-material/Map";

const MapButton = ({ coorLatitude = null, coorLongitud = null }) => {
    const isDisabled = coorLatitude === null || coorLongitud === null;
    const mapUrl = `https://maps.google.com/maps/place/${coorLatitude},${coorLongitud}`;

    return (
        <IconButton
            disabled={isDisabled}
            href={isDisabled ? undefined : mapUrl}
            target="_blank"
            sx={{
                backgroundColor: isDisabled ? "#ebebe4" : "#008e1e",
                color: isDisabled ? "#a8a8a8" : "#ffffff",
                width: "35px",
                height: "35px",
                borderRadius: 2,
                border: `2px solid ${isDisabled ? "#ebebe4" : "#008e1e"}`,
                "&:hover": {
                    backgroundColor: isDisabled ? "#ebebe4" : "#006b17",
                    color: isDisabled ? "#a8a8a8" : "#dcdcdc",
                    border: `2px solid ${isDisabled ? "#ebebe4" : "#006b17"}`,
                },
            }}
            title="Mostrar ubicación"
        >
            <MapIcon />
        </IconButton>
    );
};


export default MapButton;